/*jshint esversion: 6 */

import WidgetShortList from "../widgets/WidgetShortList";
import setupVideoTriggers from "../widgets/WidgetButtonAdvance";
import advanceVideo from "../widgets/WidgetVideoAdvance";
import convertVimeoTimestampToSeconds from "../widgets/WidgetVimeoTimestampToSeconds";
import GenericSearch from '../forms/search/GenericSearch.js';
import CategorySearch from '../forms/search/CategorySearch.js';
import FilterSearch from '../forms/search/FilterSearch.js';
import WidgetVideoRatingForm from "../widgets/WidgetVideoRatingForm";
import WidgetVideoTranscript from "../widgets/WidgetVideoTranscript";
import WidgetVideoViewsManager from "../widgets/WidgetVideoViewsManager";
import WidgetVideoView from "../widgets/WidgetVideoView";

GenericSearch();
FilterSearch();
CategorySearch({
    locale: LOCALE,
    env: ENV,
});

WidgetShortList({
    selector: 'btn-shortlist',
    locale: LOCALE,
    env: ENV,
    route: "/widget/shortlist/%type%/%id%"
});

let ratingForm = WidgetVideoRatingForm({
    locale: LOCALE,
    env: ENV,
    route: "/widget/video/%id%/rating"
});

setupVideoTriggers("button.trigger");


let ratingOpenBtn = ratingForm.getDialogOpenBtn();
let ratingSubmitBtn = ratingForm.getDialogSubmitBtn();

let id = null;
let btn = document.querySelector('button#btn-cite-show');
if (btn) {
    id = btn.getAttribute('data-id');
}

if (ratingOpenBtn) {
    ratingOpenBtn.onclick = function () {
        console.log('open rating form');
        ratingForm.buildForm(id);
    };
}

if (ratingSubmitBtn) {
    ratingSubmitBtn.onclick = function () {
        console.log('submit rating form');
        ratingForm.submitForm();
    };
}

//////////////////////////////////////////////////////////////////////////////////////////////////////////////////////
// The video rating modal control system
//////////////////////////////////////////////////////////////////////////////////////////////////////////////////////

let iframe = document.querySelector('iframe');
let ratingListenerOn = true;
let vimeoPlayer;

if (typeof Vimeo == "undefined") {
    console.log("Warning: the Vimeo object is not available");
} else {
    vimeoPlayer = new Vimeo.Player(iframe);
    vimeoPlayer.on('pause', function() {
        if (ratingListenerOn) {
            ratingForm.buildForm(id);
            ratingListenerOn = false;
        }
    });
    vimeoPlayer.on('ended', function() {
        if (ratingListenerOn) {
            ratingForm.buildForm(id);
            ratingListenerOn = false;
        }
    });
}

//////////////////////////////////////////////////////////////////////////////////////////////////////////////////////
// The video view counter system
//////////////////////////////////////////////////////////////////////////////////////////////////////////////////////

if (typeof vimeoPlayer != "undefined") {
    WidgetVideoViewsManager({
        id: id,
        player: vimeoPlayer
    });
}

//////////////////////////////////////////////////////////////////////////////////////////////////////////////////////
// The video transcript control system
//////////////////////////////////////////////////////////////////////////////////////////////////////////////////////

let transcriptWidget = WidgetVideoTranscript({
    wrapperClass: "transcript",
    contentClass: "content",
    buttonClass: "transcript-button"
});

let transcript = transcriptWidget.getTranscript();
let transcriptBtn = transcriptWidget.getTranscriptBtn();
let transitionDuration_ms = 500;
let transcriptTopOffset = 100; // pixels

if (transcriptBtn) {
    transcriptBtn.onclick = function () {
        if (transcriptForeign && transcriptForeign.classList.contains('active')) {
            transcriptWidgetForeign.toggleDisplayTranscript(transcriptForeign);
            transcriptWidgetForeign.toggleBtn(transcriptBtnForeign);
        }
        transcriptWidget.toggleBtn(transcriptBtn);
        transcriptWidget.toggleDisplayTranscript(transcript);
        if (transcript.classList.contains('active')) {
            transcriptWidget.scrollToElement(document.documentElement, transcript.offsetTop - transcriptTopOffset, transitionDuration_ms);
        } else {
            transcriptWidget.scrollToElement(document.documentElement, document.documentElement.offsetTop, transitionDuration_ms);
        }
    };
}

// Support foreign transcripts

let transcriptWidgetForeign = WidgetVideoTranscript({
    wrapperClass: "transcript-foreign",
    contentClass: "content",
    buttonClass: "transcript-button-foreign"
});

let transcriptForeign = transcriptWidgetForeign.getTranscript();
let transcriptBtnForeign = transcriptWidgetForeign.getTranscriptBtn();

if (transcriptBtnForeign) {
    transcriptBtnForeign.onclick = function () {
        if (transcript && transcript.classList.contains('active')) {
            transcriptWidget.toggleDisplayTranscript(transcript);
            transcriptWidget.toggleBtn(transcriptBtn);
        }
        transcriptWidgetForeign.toggleBtn(transcriptBtnForeign);
        transcriptWidgetForeign.toggleDisplayTranscript(transcriptForeign);
        if (transcriptForeign.classList.contains('active')) {
            // NB: transcript.offsetTop is used here otherwise the offset can be large if the foreign transcript transition has not completed
            transcriptWidgetForeign.scrollToElement(document.documentElement, transcript.offsetTop - transcriptTopOffset, transitionDuration_ms);
        } else {
            transcriptWidgetForeign.scrollToElement(document.documentElement, document.documentElement.offsetTop, transitionDuration_ms);
        }
    };
}

//////////////////////////////////////////////////////////////////////////////////////////////////////////////////////
// Update the video views field
// This should become redundant once the ESI version is in place.
//////////////////////////////////////////////////////////////////////////////////////////////////////////////////////

// WidgetVideoView({
//     selector: 'video-detail-views',
//     locale: LOCALE,
//     env: ENV,
//     route: "/widget/video/%id%/views"
// });

//////////////////////////////////////////////////////////////////////////////////////////////////////////////////////
// Video advance mechanism. Uses a Vimeo style timestamp (e.g. #t=3m45s
//////////////////////////////////////////////////////////////////////////////////////////////////////////////////////

window.onload = function () {
    let hash = window.location.hash;
    if (hash && hash.match(/^#t=.+/)) {
        let seconds = convertVimeoTimestampToSeconds(hash);
        console.log(`hash: ${hash} seconds: ${seconds}`)
        advanceVideo(seconds);
    } else {
        console.log(`hash not recognised: ${hash}`);
    }
}